import { render, staticRenderFns } from "./DxAlertDisplay.vue?vue&type=template&id=4da02408&scoped=true"
import script from "./DxAlertDisplay.vue?vue&type=script&lang=ts"
export * from "./DxAlertDisplay.vue?vue&type=script&lang=ts"
import style0 from "./DxAlertDisplay.vue?vue&type=style&index=0&id=4da02408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da02408",
  null
  
)

export default component.exports